export const listTefTransactionTypes = [
  { textStatus: 'Corriente', valueStatus: 'Corriente' },
  { textStatus: 'Diferido', valueStatus: 'Diferido' },
  { textStatus: 'Anulación', valueStatus: 'Anulacion' },
  { textStatus: 'Reverso', valueStatus: 'Reverso' },
  { textStatus: 'Pago electrónico PayClub', valueStatus: 'Pago electronico PayClub' },
]

export const listTefTransactionStatus = [
  { textStatus: 'Aprobado', valueStatus: 'A' },
  { textStatus: 'Error', valueStatus: 'E' },
  { textStatus: 'Pendiente', valueStatus: 'P' },
  { textStatus: 'Cancelada', valueStatus: 'C' },
  { textStatus: 'Todos', valueStatus: 'T' },
]
